import React from "react";
import { Link } from "react-router-dom";
import PersonalAndCreditInfo from "./PersonalAndCreditInfo";
import useConfirmBooking from "../../hooks/useConfirmBooking";
import { RefundableContent, ProductContent } from "protect-group-pulse-react"
import "../../components/Booking/BookFlight.css";
import useUpdateQuoteData from "../../hooks/useUpdateQuoteData";

const ConfirmBooking = ({ baseCostValue }) => {
    const {
        handleMakePayment,
        formatCardNumber,
        formatExpirationDate,
        isValidForm,
        numPassengers,
        selectedDate,
        originCode,
        destinationCode
    } = useConfirmBooking()

    const formValid = isValidForm()

    const {
        refundState: {
            totalValue,
            bookingCost,
            products
        }
    } = useUpdateQuoteData(
        baseCostValue,
        numPassengers,
        selectedDate,
        originCode,
        destinationCode
    )

    return (
        <div className="container">
            <h2>Booking Info</h2>

            <div className="boxing-container">
                <h3>Pricing</h3>
                <div className="pricing-box">
                    <div className="pricing-item">
                        <div>
                            <h4>Element</h4>
                            {`${originCode} → ${destinationCode} (x${numPassengers})`}
                            {products?.length > 0 && (
                                <>
                                    {products
                                        .slice()
                                        .sort((a, b) => a.productId - b.productId)
                                        .map((product, index) => (
                                            <p key={index}>{product.label}</p>
                                        ))}
                                </>
                            )}
                        </div>
                        <div>
                            <h4>Cost</h4>
                            <p>{bookingCost} USD</p>
                            {products?.length > 0 && (
                                <>
                                    {products
                                        .slice()
                                        .sort((a, b) => a.productId - b.productId)
                                        .map((product, index) => (
                                            <p key={index}>
                                                {product.sold ? product.formattedValue : "0.00"}
                                            </p>
                                        ))}
                                </>
                            )}
                        </div>
                    </div>
                </div>

                <div className="price">
                    <div className="element-pricing totalPrice">
                        <h4>Total price</h4>
                        <p>{totalValue} USD</p>
                    </div>
                </div>

                <RefundableContent/>
                <ProductContent/>

                <PersonalAndCreditInfo
                    formatCardNumber={formatCardNumber}
                    formatExpirationDate={formatExpirationDate}
                />

                <Link to={{pathname: "/thanks"}}>
                    <button
                        className="book-button"
                        onClick={handleMakePayment}
                        disabled={!formValid}>{!formValid ? 'Fields missing' : 'PAY NOW'}
                    </button>
                </Link>
            </div>
        </div>
    );
};

export default ConfirmBooking;